import {combineReducers} from 'redux';

import auth from './auth';
import device from './device';
import dealers from './dealers';
import register from './register';

export default combineReducers({auth, device, dealers, register});
